<template lang="pug">
  .cart-refill-cart.xs-12
    .next-shipment.xs-pt-50m.sm-pt-100m
      p.xs-f-small.max-at-tweak.light.xs-mb-50m.sm-mb-150m Your&nbsp;
        a(href="/dashboard/welcome#next-shipment") next auto delivery
        |  will ship on {{ refillCart.nextShipment.next | moment("MMM D, YYYY") }}

    .refill-items
      transition-group(name="fade" tag="div")
        CartRefillCartItem(v-for="item in refillCartItems" :item="item" :key="item.id")

    .xs-12.xs-mb-150m.xs-mt-100m
      a(@click="combineRefillWithCart").xs-f-small.max-at-tweak.semi-bold.upper Ship it now with current bag &#8250;
  
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import { shipRefillWithCart } from "../../../services/vueCartSvc";

  export default {
    name: "CartRefillCart",
    inject: ['getObjProperty'],

    components: {
      CartRefillCartItem: () => import('./CartRefillCartItem')
    },

    computed: {
      ...mapState('refillCart', ['refillCart']),
      ...mapGetters('refillCart', ['refillCartItems'])
    },

    methods: {
      ...mapActions('modal', ['showModal']),

      combineRefillWithCart() {
        var subscriptionId;
        this.refillCartItems.some(item => {
          if (item.subscription_id) {
            subscriptionId = item.subscription_id;
            return true;
          }
        });

        // check for existing pending orders
        var payload = {
          subscriptionId: subscriptionId
        };

        shipRefillWithCart(payload).then(() => {
          window.location = '/checkout';
        }).catch(err => {
          console.log({err});
          if (this.getObjProperty(err, 'response.data.code') == 'PENDING_ORDERS') {
            this.showModal({ component: './Cart/CartRefillCart/CartSubPendingModal' })
          } else {
            this.$store.dispatch('notifyError');
          }
        });
      }
    }
   }
</script>

<style scoped lang="stylus">
  .cart-refill-cart
    background-color color-fog-mist
    padding 0 1.5em

</style>